"use strict";

exports.__esModule = true;
exports.SpacingMode = exports.RotateMode = exports.PositionMode = exports.PathConstraintData = void 0;

var _ConstraintData2 = require("./ConstraintData");

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/** Stores the setup pose for a {@link PathConstraint}.
 *
 * See [path constraints](http://esotericsoftware.com/spine-path-constraints) in the Spine User Guide. */
var PathConstraintData = /*#__PURE__*/function (_ConstraintData) {
  _inheritsLoose(PathConstraintData, _ConstraintData);

  function PathConstraintData(name) {
    var _this;

    _this = _ConstraintData.call(this, name, 0, false) || this;
    /** The bones that will be modified by this path constraint. */

    _this.bones = new Array();
    /** The slot whose path attachment will be used to constrained the bones. */

    _this.target = null;
    /** The mode for positioning the first bone on the path. */

    _this.positionMode = null;
    /** The mode for positioning the bones after the first bone on the path. */

    _this.spacingMode = null;
    /** The mode for adjusting the rotation of the bones. */

    _this.rotateMode = null;
    /** An offset added to the constrained bone rotation. */

    _this.offsetRotation = 0;
    /** The position along the path. */

    _this.position = 0;
    /** The spacing between bones. */

    _this.spacing = 0;
    _this.mixRotate = 0;
    _this.mixX = 0;
    _this.mixY = 0;
    return _this;
  }

  return PathConstraintData;
}(_ConstraintData2.ConstraintData);
/** Controls how the first bone is positioned along the path.
 *
 * See [position](http://esotericsoftware.com/spine-path-constraints#Position) in the Spine User Guide. */


exports.PathConstraintData = PathConstraintData;
var PositionMode;
exports.PositionMode = PositionMode;

(function (PositionMode) {
  PositionMode[PositionMode["Fixed"] = 0] = "Fixed";
  PositionMode[PositionMode["Percent"] = 1] = "Percent";
})(PositionMode || (exports.PositionMode = PositionMode = {}));
/** Controls how bones after the first bone are positioned along the path.
 *
 * See [spacing](http://esotericsoftware.com/spine-path-constraints#Spacing) in the Spine User Guide. */


var SpacingMode;
exports.SpacingMode = SpacingMode;

(function (SpacingMode) {
  SpacingMode[SpacingMode["Length"] = 0] = "Length";
  SpacingMode[SpacingMode["Fixed"] = 1] = "Fixed";
  SpacingMode[SpacingMode["Percent"] = 2] = "Percent";
  SpacingMode[SpacingMode["Proportional"] = 3] = "Proportional";
})(SpacingMode || (exports.SpacingMode = SpacingMode = {}));
/** Controls how bones are rotated, translated, and scaled to match the path.
 *
 * See [rotate mix](http://esotericsoftware.com/spine-path-constraints#Rotate-mix) in the Spine User Guide. */


var RotateMode;
exports.RotateMode = RotateMode;

(function (RotateMode) {
  RotateMode[RotateMode["Tangent"] = 0] = "Tangent";
  RotateMode[RotateMode["Chain"] = 1] = "Chain";
  RotateMode[RotateMode["ChainScale"] = 2] = "ChainScale";
})(RotateMode || (exports.RotateMode = RotateMode = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7QUE4QkE7Ozs7OztBQUlBOzs7SUFHYUEsa0I7OztFQThCWiw0QkFBYUMsSUFBYixFQUF5QjtJQUFBOztJQUN4QixtQ0FBTUEsSUFBTixFQUFZLENBQVosRUFBZSxLQUFmO0lBN0JEOztJQUNBLGNBQVEsSUFBSUMsS0FBSixFQUFSO0lBRUE7O0lBQ0EsZUFBbUIsSUFBbkI7SUFFQTs7SUFDQSxxQkFBNkIsSUFBN0I7SUFFQTs7SUFDQSxvQkFBMkIsSUFBM0I7SUFFQTs7SUFDQSxtQkFBeUIsSUFBekI7SUFFQTs7SUFDQSx1QkFBeUIsQ0FBekI7SUFFQTs7SUFDQSxpQkFBbUIsQ0FBbkI7SUFFQTs7SUFDQSxnQkFBa0IsQ0FBbEI7SUFFQSxrQkFBWSxDQUFaO0lBQ0EsYUFBTyxDQUFQO0lBQ0EsYUFBTyxDQUFQO0lBRXlCO0VBRXhCOzs7RUFoQ3NDQywrQjtBQW1DeEM7Ozs7OztBQUdBLElBQVlDLFlBQVo7OztBQUFBLFdBQVlBLFlBQVosRUFBd0I7RUFBR0E7RUFBT0E7QUFBUyxDQUEzQyxFQUFZQSxZQUFZLDRCQUFaQSxZQUFZLE1BQXhCO0FBRUE7Ozs7O0FBR0EsSUFBWUMsV0FBWjs7O0FBQUEsV0FBWUEsV0FBWixFQUF1QjtFQUFHQTtFQUFRQTtFQUFPQTtFQUFTQTtBQUFjLENBQWhFLEVBQVlBLFdBQVcsMkJBQVhBLFdBQVcsTUFBdkI7QUFFQTs7Ozs7QUFHQSxJQUFZQyxVQUFaOzs7QUFBQSxXQUFZQSxVQUFaLEVBQXNCO0VBQUdBO0VBQVNBO0VBQU9BO0FBQVksQ0FBckQsRUFBWUEsVUFBVSwwQkFBVkEsVUFBVSxNQUF0QiIsIm5hbWVzIjpbIlBhdGhDb25zdHJhaW50RGF0YSIsIm5hbWUiLCJBcnJheSIsIkNvbnN0cmFpbnREYXRhIiwiUG9zaXRpb25Nb2RlIiwiU3BhY2luZ01vZGUiLCJSb3RhdGVNb2RlIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9QYXRoQ29uc3RyYWludERhdGEudHMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=